module.exports = false;




//////////////////
// WEBPACK FOOTER
// ./node_modules/detect-node/browser.js
// module id = 881
// module chunks = 37